"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var attribute = function attribute(element) {
  return function (name) {
    return element.map(function (e) {
      return e[name];
    });
  };
};

exports.default = attribute;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@standard-library/unknot/build/attribute.js
// module id = 164
// module chunks = 0